<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div class="modal-mask" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
          <div class="modal-content p-2">
            <div class="modal-header">
              <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="maheading_2">
                <h5 class="modal-title"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-qr-code w-5 h-5 text-[#00ACEE]" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:107:12" data-component-name="QrCode"><rect width="5" height="5" x="3" y="3" rx="1"></rect><rect width="5" height="5" x="16" y="3" rx="1"></rect><rect width="5" height="5" x="3" y="16" rx="1"></rect><path d="M21 16h-3a2 2 0 0 0-2 2v3"></path><path d="M21 21v.01"></path><path d="M12 7v3a2 2 0 0 1-2 2H7"></path><path d="M3 12h.01"></path><path d="M12 3h.01"></path><path d="M12 16v.01"></path><path d="M16 12h1"></path><path d="M21 12v.01"></path><path d="M12 21v-1"></path></svg> Manage Invitations</h5>
                <p class="mm-desc">
                  View, edit, or remove saved invitation links and QR codes. Update the
                  target or change the password at any time.
                </p>
              </div>

              <div class="mm-create">
                <button type="button" class="mm-btn mm-btn--orange mm-btn--full" @click="openCreateInviteModal()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus w-4 h-4 mr-2" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:123:14" data-component-name="Plus"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg> <span>Create Invitation</span>
                </button>
              </div>


              <div class="mm-list">
                <div v-if="invitations.length === 0" class="mm-empty">
                  <QrCode :size="40" class="mm-empty-icon" />
                  <p>No invitations yet. Use "Create Invitation" to create one.</p>
                </div>

                <template v-else>
                  <div v-for="inv in invitations" :key="inv.id">
                    <!-- Edit mode -->
                    <div v-if="editingId === inv.id && editDraft" class="mm-card mm-card--edit">
                      <p class="mm-card-title">Edit invitation</p>
                      <InvitationFields
                        v-model="editDraft"
                        :locations="locations"
                        :locationType="locationType"
                        :id-prefix="`edit-${inv.id}`"
                      />
                      <div class="mm-actions">
                        <button type="button" class="mm-btn mm-btn--blue mm-grow" @click="saveEdit">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-save w-4 h-4 mr-2" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:150:22" data-component-name="Save"><path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"></path><path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"></path><path d="M7 3v4a1 1 0 0 0 1 1h7"></path></svg> <span>Save changes</span>
                        </button>
                        <button type="button" class="mm-btn mm-btn--outline" @click="cancelEdit">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x w-4 h-4 mr-2" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:154:22" data-component-name="X"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg> <span>Cancel</span>
                        </button>
                      </div>
                    </div>

                    <!-- Display mode -->
                    <div v-else class="mm-card">
                      <div class="mm-card-row">
                        <div class="mm-card-info">
                          <p class="mm-card-title">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin w-3.5 h-3.5 text-muted-foreground shrink-0" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:164:24" data-component-name="MapPin"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg> {{ inv.locationName }}
                          </p>
                          <p class="mm-sub"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-route w-3 h-3 shrink-0" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:168:24" data-component-name="Route"><circle cx="6" cy="19" r="3"></circle><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"></path><circle cx="18" cy="5" r="3"></circle></svg> {{ inv.pathwayName }}</p>
                          <p class="mm-sub"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-footprints w-3 h-3 shrink-0" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:172:24" data-component-name="Footprints"><path d="M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z"></path><path d="M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z"></path><path d="M16 17h4"></path><path d="M4 13h4"></path></svg> {{ inv.stepName }}</p>
                        </div>
                        <span class="mm-date">{{ inv.createdAt }}</span>
                      </div>

                      <div class="mm-actions mm-wrap">
                        <button type="button" class="mm-btn mm-btn--outline mm-btn--sm" @click="toggleExpand(inv.id)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-qr-code w-3.5 h-3.5 mr-1.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:188:22" data-component-name="QrCode"><rect width="5" height="5" x="3" y="3" rx="1"></rect><rect width="5" height="5" x="16" y="3" rx="1"></rect><rect width="5" height="5" x="3" y="16" rx="1"></rect><path d="M21 16h-3a2 2 0 0 0-2 2v3"></path><path d="M21 21v.01"></path><path d="M12 7v3a2 2 0 0 1-2 2H7"></path><path d="M3 12h.01"></path><path d="M12 3h.01"></path><path d="M12 16v.01"></path><path d="M16 12h1"></path><path d="M21 12v.01"></path><path d="M12 21v-1"></path></svg>
                          <span>{{ expandedId === inv.id ? "Hide QR" : "Show QR" }}</span>
                          <svg v-if="expandedId === inv.id" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-up w-3.5 h-3.5 ml-1" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:190:47" data-component-name="ChevronUp"><path d="m18 15-6-6-6 6"></path></svg>
                          <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down w-3.5 h-3.5 ml-1" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:190:92" data-component-name="ChevronDown"><path d="m6 9 6 6 6-6"></path></svg>
                        </button>
                        <button type="button" class="mm-btn mm-btn--outline mm-btn--sm" @click="startEdit(inv)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pencil w-3.5 h-3.5 mr-1.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:193:22" data-component-name="Pencil"><path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"></path><path d="m15 5 4 4"></path></svg> <span>Edit</span>
                        </button>
                        <button type="button" class="mm-btn mm-btn--danger mm-btn--sm" @click="deleteId = inv.id">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2 lucide-trash-2 w-3.5 h-3.5 mr-1.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/admin/ManageInvitationsSheet.tsx:203:22" data-component-name="Trash2"><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path><path d="M3 6h18"></path><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg> <span>Delete</span>
                        </button>
                      </div>
                      <InvitationQRDisplay
                        v-if="expandedId === inv.id"
                        :invitation="inv"
                        basePath="http://mentoring.uincd.com/"
                      />

                    </div>
                  </div>
                </template>
              </div>



            </div>
            <div class="modal-footer mb-5"></div>
          </div>
        </div>
      </div>
    </transition>
    <CreateInvite
      :isModalVisible="isCreateInviteModalVisible"
      :locations="locations"
      :defaultLocationId="defaultLocationId"
      :locationType="locationType"
      ref="CreateInviteModal"
      @close="closeCreateInvite">
    </CreateInvite>

    <!-- Delete confirm -->
    <div v-if="deleteId" class="mm-confirm-root">
      <div class="mm-confirm-overlay" @click="deleteId = null"></div>
      <div class="mm-confirm-box" role="alertdialog" aria-modal="true">
        <h3 class="mm-confirm-title">Delete this invitation?</h3>
        <p class="mm-confirm-desc">
          The link and QR code will stop working immediately. This can't be undone.
        </p>
        <div class="mm-confirm-actions">
          <button type="button" class="mm-btn mm-btn--outline" @click="deleteId = null">
            Cancel
          </button>
          <button type="button" class="mm-btn mm-btn--orange" @click="confirmDelete">
            Delete
          </button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import axios from 'axios';
import InvitationQRDisplay from "./InvitationQRDisplay.vue";
import InvitationFields from "./InvitationFields.vue";
import CreateInvite from "./create_invite.vue";
import { notify } from "../../toastStore";

function toDraft(inv) {
  return {
    id: inv.id,
    locationId: inv.locationId,
    locationName: inv.locationName,
    pathwayId: inv.pathwayId,
    pathwayName: inv.pathwayName,
    stepId: inv.stepId,
    stepName: inv.stepName,
    password: inv.password,
  };
}


export default {
  props: ['isModalVisible'],
  data() {
    return {
      isInviteFormOpen: false,
      pathways: [],
      selectedPathway: '',
      pathwaySteps: [],
      selectedStep: '',
      accessPassword: '',
      showPassword: false,
      generatedLink: '',
      showQRCode: false,
      invitations: [],
      expandedId: '',
      editingId: '',
      locations: [],
      locationType: 0,
      defaultLocationId: 0,
      isCreateInviteModalVisible: false,
      deleteId: null,
			qrString: 'https://api-mentoring.uincd.com/custom/invitation/qr/tttttt',
      editDraft: {
				locationId: "",
				locationName: "",
				pathwayId: "",
				pathwayName: "",
				stepId: "",
				stepName: "",
				password: "",
			},
    }
  },
  computed: {
    isComplete() {
      const d = this.editDraft;
      return !!d.pathwayId && !!d.stepId && !!d.password.trim();
    },
    canGenerate() {
      return this.selectedPathway && this.selectedStep && this.accessPassword && this.accessPassword.length >= 4;
    },
    qrSrc() {
      if (!this.generatedLink) return '';
      return 'https://chart.googleapis.com/chart?cht=qr&chs=200x200&chl=' + encodeURIComponent(this.generatedLink);
    }
  },
  components: {
    InvitationQRDisplay,
    InvitationFields,
    CreateInvite,
  },
  methods: {
    closeCreateInvite() {
      this.getInviteLists();
      this.isCreateInviteModalVisible = false;
    },
    confirmDelete() {
      if (!this.deleteId) return;
      axios('/delete-account-invitation/' + this.deleteId,
				{
					method: 'DELETE',
				}
			)
      .then((resp) => {
        this.getInviteLists();
        notify({
          title: "Invitation deleted" 
        });
			})
      .catch(error => {

      });
      this.deleteId = null;
    },
    openCreateInviteModal() {
     this.isCreateInviteModalVisible = true;
     this.$refs.CreateInviteModal.loadInitialData();
    },
    formatDate(ts) {
      return new Date(ts).toLocaleDateString();
    },
    toggleExpand(id) {
      this.expandedId = this.expandedId === id ? null : id;
    },
    startEdit(inv) {
      this.editingId = inv.id;
      this.editDraft = toDraft(inv);
      this.expandedId = null;
    },
    cancelEdit() {
      this.editingId = null;
      this.editDraft = null;
    },
    saveEdit() {
      var flag = 0;
      const d = this.editDraft;
      if (!d.locationId || !d.pathwayId || !d.stepId || !d.password.trim()) {
        notify({
          title: "Incomplete",
          description: "Account, pathway, step, and password are all required.",
          variant: "destructive",
        });
        flag = 1;
        return;
      }
      if (flag == 0) {
        axios('/edit-account-invitation',
          {
            method: 'POST',
            data:
            {
              id: this.editDraft.id,
              pathwayId: this.editDraft.pathwayId,
              stepId: this.editDraft.stepId,
              passcode: this.editDraft.password,
              locationId: this.editDraft.locationId,
            },
          }
        )
        .then((resp) => {
          this.cancelEdit();
          this.getInviteLists();
          notify({
            title: "Invitation updated" 
          });
        })
        .catch(error => {

        });
      }
      
    },
    hide() {
      this.resetForm();
      this.$emit('close');
    },
    openInviteForm() {
      this.isInviteFormOpen = true;
      this.loadInitialData();
    },
    // when user clicks Show QR on an existing invite
    showQr(invite) {
      this.isInviteFormOpen = true;
      this.selectedPathway = invite.pathway || '';
      this.selectedStep = invite.step || '';
      this.accessPassword = invite.password || '';
      this.generatedLink = invite.link || '';
      this.showQRCode = true;
    },
    // edit existing invite
    editInvite(invite) {
      this.isInviteFormOpen = true;
      this.selectedPathway = invite.pathway || '';
      this.selectedStep = invite.step || '';
      this.accessPassword = invite.password || '';
      this.generatedLink = '';
      this.showQRCode = false;
    },
    resetForm() {
      this.isInviteFormOpen = false;
      this.editingId = '';
      this.expandedId = '';
      this.deleteId = null;
      this.selectedPathway = '';
      this.pathwaySteps = [];
      this.selectedStep = '';
      this.accessPassword = '';
      this.showPassword = false;
      this.generatedLink = '';
      this.showQRCode = false;
    },
    getInviteLists() {
      axios('/get-account-invite-lists',
      {
        method: 'GET',
        params: {
          accountId: this.$store.state.user_accountid,
        }
      })
      .then(resp => {
        this.invitations = resp.data;       
      })
      .catch(() => {
      });

    },
    loadInitialData() {
      this.invitations = [];
      this.resetForm();
      this.getInviteLists();
      axios('/get-locations-create-invite',
      {
        method: 'GET',
        params: {
          accountId: this.$store.state.user_accountid,
        }
      })
      .then(resp => {
        this.locations = resp.data.locations;       
        this.locationType = resp.data.enterpriseFlag;
        if (this.locationType == 0) {
          this.defaultLocationId = this.locations[0].id;
        }       
      })
      .catch(() => {
      });

    },
    onPathwayChange() {
      // try to load pathway steps for selected pathway
      this.pathwaySteps = [];
      this.selectedStep = '';
      this.pathwaySteps = [ { id: 'step1', name: 'Step 1' }, { id: 'step2', name: 'Step 2' } ];
    },
    deleteInvite(idx) {
      this.invites.splice(idx,1);
    },
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    regeneratePassword() {
    },
    generateInvite() {
      // construct invite link — adapt as needed for backend endpoints
      const account = (this.$store && this.$store.state && this.$store.state.user_accountid) ? this.$store.state.user_accountid : '';
      const base = window.location.origin;
      const link = `${base}/invite?account=${encodeURIComponent(account)}&pathway=${encodeURIComponent(this.selectedPathway)}&step=${encodeURIComponent(this.selectedStep)}&pw=${encodeURIComponent(this.accessPassword)}`;
      this.generatedLink = link;
      this.showQRCode = true;
    },
    copyLink() {
      if (!this.generatedLink) return;
      navigator.clipboard.writeText(this.generatedLink).then(() => {
        // optionally show toast
      }).catch(() => {
        // fallback: select + execCommand
        const el = document.createElement('textarea');
        el.value = this.generatedLink;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      });
    }
  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}
@keyframes slide-in { 0% { -webkit-transform: translateX(100%);} 100% { -webkit-transform: translateX(0%);} }
@-webkit-keyframes slide-in { 0% { transform: translateX(100%);} 100% { transform: translateX(0%);} }
.modal-dialog { max-width: 90%; }
@media (min-width: 992px) { .modal-lg, .modal-xl { width: 700px; } }
@media (max-width: 576px){ .modal-dialog.modal-dialog-slideout { width: 80% } }
.modal-dialog-slideout { min-height: 100%; margin: 0 0 0 auto; background: #fff; }
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.maheading_2 { width: 75%; }
.subscription_box { border: 1px solid #e6e6e6; }
.ma-orange-btn { background-color: #f26422; color: #fff; border: none; }
.invite-card { background: #fff; border: 1px solid #ececec; }
.text-\[\#00ACEE\] {
    color: #00ACEE;
}
.modal-title {
  font-size: 1.125rem;
  color: #002F42;
  font-weight: 600;
  margin-bottom: 10px;
}
.mm-desc {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7785;
}
.mm-create {
  margin-top: 24px;
}
.mm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.mm-btn--sm {
  height: 32px;
  padding: 0 10px;
  font-size: 13px;
}
.mm-btn--full {
  width: 100%;
}
.mm-btn--orange {
  background: #ee4200;
  color: #fff;
  border-color: hsl(from hsl(197 100% 47%) h s calc(l + -8) / alpha);
  font-weight: 600;
}
.mm-btn--orange:hover {
  background: #cc3800;
}
.mm-btn--blue {
  background: #00acee;
  color: #fff;
}
.mm-btn--blue:hover {
  background: #0095d0;
}
.mm-btn--outline {
  background: #fff;
  border-color: #d6dde1;
  color: #1f2a30;
}
.mm-btn--outline:hover {
  background: #f3f5f6;
}
.mm-btn--danger {
  background: #fff;
  border-color: rgba(238, 66, 0, 0.3);
  color: #ee4200;
}
.mm-btn--danger:hover {
  background: rgba(238, 66, 0, 0.1);
}
.mm-list {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mm-empty {
  border: 1px dashed #d6dde1;
  border-radius: 12px;
  background: rgba(0, 47, 66, 0.02);
  padding: 32px;
  text-align: center;
  color: #6b7785;
  font-size: 14px;
}
.mm-empty-icon {
  color: #c3ccd1;
  display: block;
  margin: 0 auto 12px;
}
.mm-card {
  border: 1px solid #e4e9ec;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mm-card--edit {
  background: rgba(0, 47, 66, 0.03);
  gap: 16px;
}
.mm-card-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #002f42;
}
.mm-card-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.mm-card-info {
  min-width: 0;
}
.mm-sub {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 0;
  font-size: 12px;
  color: #6b7785;
}
.mm-muted-icon {
  color: #6b7785;
}
.mm-date {
  font-size: 11px;
  color: #6b7785;
  white-space: nowrap;
}
.mm-actions {
  display: flex;
  gap: 8px;
}
.mm-wrap {
  flex-wrap: wrap;
}
.mm-grow {
  flex: 1 1 auto;
}
/* confirm dialog */
.mm-confirm-root {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mm-confirm-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
}
.mm-confirm-box {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}
.mm-confirm-title {
  margin: 0 0 8px;
  font-size: 17px;
  font-weight: 600;
  color: #002f42;
}
.mm-confirm-desc {
  margin: 0 0 20px;
  font-size: 14px;
  color: #6b7785;
}
.mm-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.text-muted-foreground {
    color: #627384;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/manage_invite.vue